import {FLEETACTHISTORY} from '../actiontype'
import request from '@/utils/request'
import {fleetActHistoryApi} from '@/api'
import inlineSign from '@/utils/inlinesign'
export const fleetacthistoryAction = (params) => {
  const action = (data) => (
    {
      type: FLEETACTHISTORY,
      data
    }
  )
  return async (dispatch) => {
    let data = await request.post(fleetActHistoryApi,{
        ...params
    },{
        ...inlineSign
    })
    if(data.data.data){
        dispatch(action(data.data.data))
    }
  }
}